<div class="input-select-wrapper relative">
  <ion-select
    aria-label="options"
    class="{{ config.selectClass }}"
    [placeholder]="config.placeholder"
    [multiple]="config.multiple"
    (ionChange)="handleChange($event)"
    [value]="value"
    [interface]="config.alertType ?? 'popover'"
    labelPlacement="floating"
    [label]="config.label || config.placeholder"
  >
    <ion-select-option value=""> All </ion-select-option>
    <ion-select-option
      [value]="option[config.optionsValue]"
      *ngFor="let option of config.options"
    >
      {{ option[config.optionsLabel] | titlecase }}
    </ion-select-option>
  </ion-select>
  <ion-icon
    name="chevron-down-outline"
    class="custom-select-icon mr-2 text-[24px]"
  ></ion-icon>
</div>

<!-- <div class="rounded-[5px] relative">
  <ion-select label="Floating label" label-placement="floating">
    <ion-select-option value="apple">Apple</ion-select-option>
    <ion-select-option value="banana">Banana</ion-select-option>
    <ion-select-option value="orange">Orange</ion-select-option>
  </ion-select>
  <ion-icon
    name="chevron-down-outline"
    class="custom-select-icon mr-2 text-[24px]"
  ></ion-icon>
</div> -->
